<template>
  <div class="highcharts-light trend-chart chart-container">
    <highcharts :options="chartOptions" ref="chartComponent"></highcharts>
  </div>
</template>

<script>
import {Chart} from 'highcharts-vue';
import Highcharts from 'highcharts';
import addAccessibility from 'highcharts/modules/accessibility';
import noDataToDisplay from 'highcharts/modules/no-data-to-display';
import DataService from '../../../../services/data.service';
import { parse } from 'crossroads';

addAccessibility(Highcharts);
noDataToDisplay(Highcharts);

export default {
  name: 'line-chart',
  components: {
    highcharts: Chart
  },
  props: {
    chartSeries: {
      type: Array,
      default: () => []
    },
    dateRange: {
      type: Object,
      default: undefined,
    },
    filter: {
      type: Object,
      default: undefined
    },
    panel: {
      type: Object,
      default: () => {}
    },
  },
  data: function () {
    this.filter.activeFiltersUpdated.add(this.renewRegistration.bind(this));
    return {
      categories: undefined,
      data: [],
    }
  },
  computed: {
    chartOptions: function() {
      let self = this;
      return {
        chart: {
          styledMode: true,
          type: 'line',
          height: 435
        },
        title: {
          text: undefined
        },
        lang: {
          noData: 'No Data To Display'
        },
        noData: {
          style: {
            fontSize: '14px',
            fontWeight: '400',
            color: 'var(--text-color)',
            fontFamily: 'Proxima Nova'
          }
        },
        legend: {
          align: 'left',
          layout: 'vertical',
          verticalAlign: 'middle',
          itemMarginBottom: 6,
          symbolHeight: 15,
          useHTML: true,
          itemStyle: {
            fontSize: '14px',
            color: 'var(--text-color)',
            fontFamily: 'Proxima Nova'
          },
        },
        tooltip: {
          style: {
            color: 'var(--text-color)',
            fontFamily: 'Proxima Nova'
          },
          formatter: function () {
            let value = this.y;
            let formattedValue = parseFloat(value.toFixed(2));

            if (value % 1) {
              formattedValue = Highcharts.numberFormat(value, 2);
            }

            return `<span class="highcharts-color-${this.point.colorIndex}"><b>${this.series.name}</b><br/>Value: ${formattedValue}</span>`;
          },
          useHTML: true,
        },
        credits: {
          enabled: false
        },
        xAxis: {
          categories: self.categories ? Array.from(self.categories) : [],
          labels: {
          },
          title: {
            text: self.panel.xAxisTitle || ''
          },
        },
        yAxis: {
          title: {
            text: self.panel.yAxisTitle || ''
          },
          labels: {
            formatter: function () {
              var value = this.value;

              if (value % 1) {
                return Highcharts.numberFormat(value, 2);
              }

              return value;
            },
          },
        },
        series: self.data,
      }
    }
  },
  methods: {
    renewRegistration: function() {
      DataService.deregisterPanel(this.panel, this.filter, this.dateRange);
      DataService.registerPanel(this.panel, this.filter, this.dateRange, this.updateData.bind(this));
    },
    updateData: function(data) {
      let self = this;
      let valueColumn = this.panel.valueColumn;
      let nameColumn = this.panel.nameColumn;
      let groupByColumn = this.panel.groupByColumn;
      let extractedData = [];
      let categories = new Set();
      data.forEach((dataPoint) => {
        let name = dataPoint[nameColumn];
        let groupByValue = dataPoint[groupByColumn];
        let highchartsPoint = {
          name,
          y: dataPoint[valueColumn]
        };
        categories.add(name);
        if (groupByColumn) {
          let currentSeries = extractedData.find((series) => series.name === groupByValue);
          if (currentSeries) {
            currentSeries.data.push(highchartsPoint);
          } else {
            extractedData.push({
              name: groupByValue,
              data: [highchartsPoint]
            });
          }
        } else {
          extractedData.push(highchartsPoint);
        }
      });
      this.categories = categories;
      this.data = extractedData;

      if (self.$refs.chartComponent.$el) {
        for (let i = 1; i < 10; i++) {
          self.$refs.chartComponent.$el.classList.remove('hc-series-' + i);
        }
        let valueLength = this.data.length;
        if (this.data && valueLength > 1) {
          self.$refs.chartComponent.$el.classList.add('hc-series-' + Math.min(10, valueLength));
        }
      }

    }
  },
  mounted() {
    let self = this;
    // We need to wait a bit to call reflow here; $nextTick seems to be the cleanest option.
    this.$nextTick(() => {
      if (self.$refs.chartComponent) {
        self.$refs.chartComponent.chart.reflow();
      }
    });
    DataService.registerPanel(this.panel, this.filter, this.dateRange, this.updateData);
  },
  beforeDestroy() {
    DataService.deregisterPanel(this.panel, this.filter, this.dateRange);
  },
  watch: {
    dateRange: {
      handler: function(newRange, oldVal) {
        if (!newRange.startDate.isSame(oldVal.startDate) || !newRange.endDate.isSame(oldVal.endDate)) {
          this.renewRegistration();
        }
      },
      deep: true,
    },
  },
}
</script>

<style lang="scss">
.trend-chart.chart-container {
  min-width: 280px;
  .highcharts-container {
    margin: 0 auto;
    .highcharts-legend-item span {
      font-size: 14px;
      text-transform: capitalize;
    }
    .highcharts-series {
      //cursor: pointer;
    }
  }
}
</style>
